export default {
    name: 'StrUtil',
    /**
     * 金额格式化
     * @param money     金额
     * @param currency  货币符号
     * @param digit     保留几位小数
     * @param split_3_symbol   是否需要每3位正数逗号分割 //'VND' '₫' 需要
     * @param currencyLeft   货币符号是否在左
     * @returns {string}
     */
    formatMoney(money, currency, digit, split_3_symbol = false, currencyLeft) {
        let moneyStr = this.formatNumber(money, digit, split_3_symbol);
        currency = currency || this.currency
        currencyLeft = currencyLeft || true
        if (currencyLeft) {
            return currency + ' ' + moneyStr
        } else {
            return moneyStr + ' ' + currency
        }
    },
    formatNumber(money, digit, split_3_symbol = false) {
        money = parseFloat(money || 0);

        digit = digit || parseInt(this.paramMapAll && this.paramMapAll['CURRENCY_SYMBOL_DECIMAL'] || '2')
        split_3_symbol = split_3_symbol || this.paramMapAll && this.paramMapAll['CURRENCY_SYMBOL_3NUM_SPLIT_SYMBOL'] || ''
        // 判断是否存在小数部分
        let moneyStr = money % 1 === 0 ? money.toString() : money.toFixed(digit)
        if (split_3_symbol) {
            moneyStr = moneyStr.replace(/\d(?=(?:\d{3})+\b)/g, `$&${split_3_symbol}`)
        }
        return moneyStr
    },
}
